<template>
    <div class="business">
    <div id='page-top' style='height: 160px'></div>
    <div class='business_intro'>
      <div class='bg'></div>
      <div class='title'>
        <h1>拉风汽车AI智能系统</h1>
        <p>{{titleMsg}}</p>
        <img src='../assets/imgs/business2.png' /> 
      </div>
      <div class='business_main'>
        <div>
          <h3 class='bor'><span class='borl'></span><span>业务模式</span><span class='borr'></span></h3>
          <div class='pattern'>
            <p>{{msg}}</p>
            <p>{{msg2}}</p>
          </div>
          <div class='img'>
            <img src="../assets/imgs/business1.jpg" alt="">
          </div>
        </div>
        <div>
          <h3 class='bor'><span class='borl'></span><span>主营业务</span><span class='borr'></span></h3>
          <ul>
            <li>
              <div>
                <p>库存融资业务</p>
                <span>模式多样化、利率更灵活、评估更专业精准，更好的解决车源留存及库存融资问题</span>
              </div>
            </li>
            <li>
              <div>
                <p>消费贷分期---新车、二手车</p>
                <span>手续更简单、风控模型更完善、审批流程更快捷、放款速度更高效<small>进件提报&gt;风控审核&gt;合同签署&gt;抵押放款</small></span>
              </div>
            </li>
            <li>
              <div>
                <p>车辆评估业务</p>
                <span>具有真实收售数据支持，评估定价更精准；双评定价系统分析，彻底防范道德风险；标准化评估作业，实现车辆评估数据化，提高效率与质量</span>
              </div>
            </li>
          </ul>
        </div> 
      </div>
    </div> 
    </div>
</template>

<script>
  export default {
    data() {
      return {
        titleMsg: ` 拉风汽车专注于为银行、汽车金融、融资租赁及经销商、二手车商等公司提供一站式平台服务，依托专业的二手车评估技术、强大的风控体系、数据模型以及监控措施，提供数据体系报告、风控模型报告、征信评估报告帮助其提高效率并降低运营成本。`,
        msg: `以AI智能系统平台为核心 , 业务范围包含服务上游资金方(银行/保险公司/融资租赁公司/汽车金融公司)，并为线下二手车运营商(4S店/二手车商/2级网点等)提供金融服务和二手车评估，同时也提供当地消费者二手车分期等相关业务。`,
        msg2:`结合云端及大数据提高评估准确率，解决车源留存及库存融资问题，降低寻租空间及飞单问题。目前与拉风汽车合作的700余家4S店效果明显。系统可指定资金用途及还款来源，更大程度加强资金安全型并监控流向，更易获得资金方授信。`,
      }
    }
  };
</script>

<style lang="scss" scoped>
  .business{
    position:relative;
    text-align:left;
    .bg{
      width:100%;
      margin-top: 80px;
      min-width:1088px;
      height:544px;
      background:url('../assets/imgs/business_bg.jpg') no-repeat;
      background-size:100% 544px;
      position:absolute;
      top:0;
      left:0;
    }
    // padding-top:80px;
    min-width:1088px;
    .business_intro{
      width:65%;
      min-width:936px;
      margin:0 auto;
      p{
          opacity: 0.8;
          font-size: 18px;
          letter-spacing: 0;
          line-height: 34px;
        }
      .title{
        position:relative;
        text-align:center;
        width:936px;
        color: #FFFFFF;
        margin:0 auto;
        h1{
          font-weight:normal;
          font-size:32px;
          margin-bottom:42px;
        }
        img{
          margin-top:48px;
        }
      }
      .business_main{
        padding-top:40px;
        h3{
          font-weight:normal;
          font-size:30px;
          opacity:0.54;
          margin-bottom:71px;
          line-height:34px;
          position:relative;
          text-align:center;
          span{
            display:inline-block;
          }
          .borl{
            height:1px;
            background:#ECECEC;
            position:absolute;
            top:17px;
            left:0;
            right:840px;
          }
          .borr{
            height:1px;
            background:#ECECEC;
            position:absolute;
            top:17px;
            right:0;
            left:840px;
          }
        }
        .pattern{
          p{
            text-indent:36px;
          }
        }
        .img{
          margin-top:43px;
          margin-bottom:81px;
          text-align:center;
          img{
            width:65%;
          }
        }
      }
    }
    ul{
      margin-top:40px;
      li{
        margin:38px 0;
        padding:60px;
        box-shadow: 0 1px 0 0 rgba(0,0,0,0.05);
        div{
          width:62%;
          margin:0 auto;
          min-height:120px;
          p{
            text-indent:0px;
            opacity:1;
          }
          span{
            font-size: 16px;
            color: #999999;
            letter-spacing: 0;
            line-height: 25px;
            small{
              font-size: 16px;
              display:block;
              color:#FDC642;
            }
          }
        }
      }
      li:last-child{
        box-shadow: none;
      }
      li:nth-child(1)>div{
        padding-left:200px;
        background:url('../assets/imgs/ic_kucunrongzi.png') no-repeat;
        
      }
      li:nth-child(2)>div{
        padding-right:200px;
        background:url('../assets/imgs/ic_xiaofeidai.png') no-repeat right;
        
      }
      li:nth-child(3)>div{
        padding-left:200px;
        background:url('../assets/imgs/img_cheliangpinggu.png') no-repeat;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Business.vue?478d4315